import 'ol/ol.css';
import ImageLayer from 'ol/layer/Image';
import Map from 'ol/Map';
import {easeIn, easeOut, inAndOut} from 'ol/easing.js';
import Projection from 'ol/proj/Projection';
import Static from 'ol/source/ImageStatic';
import View from 'ol/View';
import {getCenter} from 'ol/extent';
import XYZ from 'ol/source/XYZ';
import {FullScreen, Control, defaults as defaultControls} from 'ol/control';
import {DragRotate, defaults as defaultInteractions} from 'ol/interaction';
import {shiftKeyOnly} from 'ol/events/condition';
import PinchRotate from 'ol/interaction/PinchRotate';



// Map views always need a projection.  Here we just want to map image
// coordinates directly to map coordinates, so we create a projection that uses
// the image extent in pixels.


function degrees_to_radians(degrees) {
  var pi = Math.PI;
  return degrees * (pi/180);
}


// var NextWaypointControl = /*@__PURE__*/(function (Control) {
//   function NextWaypointControl(opt_options) {
//     var options = opt_options || {};

//     var button = document.createElement('button');
//     button.innerHTML = '>';

//     var element = document.createElement('div');
//     element.className = 'next-waypoint arrow-btn ol-unselectable ol-control';
//     element.appendChild(button);

//     Control.call(this, {
//       element: element,
//       target: options.target,
//     });

//     button.addEventListener('click', this.handleNextWaypoint.bind(this), false);
//   }

//   if ( Control ) NextWaypointControl.__proto__ = Control;
//   NextWaypointControl.prototype = Object.create( Control && Control.prototype );
//   NextWaypointControl.prototype.constructor = NextWaypointControl;

//   NextWaypointControl.prototype.handleNextWaypoint = function handleNextWaypoint () {
//     findNearestWaypoint('next');
//     console.log("CIAO");
//   };

//   return NextWaypointControl;
// }(Control));

// var PrevWaypointControl = /*@__PURE__*/(function (Control) {
//   function PrevWaypointControl(opt_options) {
//     var options = opt_options || {};

//     var button = document.createElement('button');
//     button.innerHTML = '<';

//     var element = document.createElement('div');
//     element.className = 'prev-waypoint arrow-btn ol-unselectable ol-control';
//     element.appendChild(button);

//     Control.call(this, {
//       element: element,
//       target: options.target,
//     });

//     button.addEventListener('click', this.handlePrevWaypoint.bind(this), false);
//   }

//   if ( Control ) PrevWaypointControl.__proto__ = Control;
//   PrevWaypointControl.prototype = Object.create( Control && Control.prototype );
//   PrevWaypointControl.prototype.constructor = PrevWaypointControl;

//   PrevWaypointControl.prototype.handlePrevWaypoint = function handlePrevWaypoint () {
//     findNearestWaypoint('prev');
//   };

//   return PrevWaypointControl;
// }(Control));





function imageSizeAfterRotation(size, degrees) {
    degrees = degrees % 180;
    if (degrees < 0) {
        degrees = 180 + degrees;
    }
    if (degrees >= 90) {
        size = [ size[1], size[0] ];
        degrees = degrees - 90;
    }
    if (degrees === 0) {
        return size;
    }
    const radians = degrees * Math.PI / 180;
    const width = (size[0] * Math.cos(radians)) + (size[1] * Math.sin(radians));
    const height = (size[0] * Math.sin(radians)) + (size[1] * Math.cos(radians));
    return [ width, height ];
}


//[left, bottom, right, top] 
var coreExtent = [0, 0, 100, 100];
var constraintExtent = [-40, -40, 140, 140];
var coreProjection = new Projection({
  	code: 'ghk-image',
  	units: 'cm',
  	extent: coreExtent,
});

var minZoom = 2;
var maxZoom = 4;
var projectView = new View({
	center: getCenter(coreExtent),
	zoom: (maxZoom - minZoom) / 2,
	maxZoom: maxZoom,
	minZoom: minZoom,
	projection: coreProjection,
    enableRotation: true,
    constrainRotation: 72,
    extent: constraintExtent,

});
var projectMap = new Map({
  	target: 'homemap',
 	view: projectView,
 	//controls: defaultControls().extend([new FullScreen(), new NextWaypointControl(), new PrevWaypointControl()]),
    controls : defaultControls({
        attribution : false,
        zoom : false,
        rotate: false,
        shiftDragZoom: false
    }),
    interactions: defaultInteractions({altShiftDragRotate: false}).extend([
        new DragRotate({condition: shiftKeyOnly}), new PinchRotate()
    ]),
   /*interactions: ol.interaction.defaults({altShiftDragRotate: false}).extend([
      new ol.interaction.DragRotate({condition: ol.events.condition.platformModifierKeyOnly})
   ])*/


});

var mapData = window.mapSource;

//if( !mapData ) return;

jQuery(mapData.elements).each(function(index) {
	let image = this;

	let imageCenter = [parseInt(image.centerX), parseInt(image.centerY)];
	let imageSize = [parseInt(image.width), parseInt(image.height)];
	let rotationAngle = parseInt(image.rotation);
		
	imageSize = imageSizeAfterRotation(imageSize, rotationAngle);
	//[left, bottom, right, top] 
	
	let x0 = imageCenter[0] - (imageSize[0]/2); 
	let y0 = (100 - imageCenter[1]) - (imageSize[1]/2); 
	let x1 = imageCenter[0] + (imageSize[0]/2); 
	let y1 = (100 - imageCenter[1]) + (imageSize[1]/2);

	let imageExtent = [x0, y0, x1, y1];
    image.extent = imageExtent;
	projectMap.addLayer(
		new ImageLayer({
	      	source: new Static({
	       		attributions: '© GHK',
	        	url: mapData.images[index],
	        	projection: coreProjection,
	        	imageExtent: imageExtent,
	      	}),
	    })
	);
});


var waypoints = mapData.viewpoints;
var waypointsLength = waypoints.length;
var baseRotation = projectView.getRotation();

var firstMove = true;
var triggeredMove = false;

var winW = window.innerWidth;
/*
projectMap.on("moveend", function(e){
    if(triggeredMove) {
    	firstMove = false;
    }
    triggeredMove = true;
});
*/

function mapMoveToClicked(waypoint) {

	let waypointCoordinates = [waypoint.centerX, 100 - waypoint.centerY];
	let rotation = waypoint.rotation*-1;
	let zoom = waypoint.zoom;
	projectView.animate({
      	center: waypointCoordinates,
      	rotation: degrees_to_radians(rotation),
      	zoom: zoom,
      	duration: 1000,
        easing: inAndOut
	});

  jQuery('#ghk-header #project-viewpoints .viewpoint-caption .caption-text').first().empty().text(waypoint.caption);
}
function mapMoveToWaypoint(waypointIndex) {
	if( waypointIndex > (waypointsLength - 1) ) {
		waypointIndex = 0;
	}
	if( waypointIndex < 0 ) {
		waypointIndex =  waypointsLength - 1;
	}	

	let waypoint = waypoints[waypointIndex];
	let waypointCoordinates = [waypoint.centerX, 100 - waypoint.centerY];
	let rotation = waypoint.rotation*-1;
	let zoom = waypoint.zoom;
	// ((5-2)/2)(x-1)^{3}+(5-((5-2)/2))

	let mediumZoom = (maxZoom-minZoom)/2;
	let actualZoom = zoom;


	let calcZoom = mediumZoom * Math.pow( (actualZoom-1), 3) + (maxZoom - mediumZoom);

    let zoomFactor = 1;

    if (winW < 1024) {
        zoomFactor = 0.85;
    }
    if (winW < 600) {
        zoomFactor = 0.65;
    }

    calcZoom = calcZoom * zoomFactor;

	projectView.animate({
      	center: waypointCoordinates,
      	rotation: degrees_to_radians(rotation),
      	zoom: calcZoom,
      	duration: 1500,
        easing: inAndOut
	});

  jQuery('#ghk-header #project-viewpoints .viewpoint-caption .caption-text').first().empty().text(waypoint.caption);
}
mapMoveToWaypoint(0);

function rad(x) {
	return x*Math.PI/180;
}

function findNearestWaypoint(direction) {
	

    var viewCenter = projectMap.getView().getCenter();
    var minDistance = 9999999999999;
    var nearestWaypoint = null;

    for( var i = 0; i < waypointsLength; i++ ) {
        var waypointX = waypoints[i].centerX;
        var waypointY = 100-waypoints[i].centerY;

        var distance = Math.hypot(viewCenter[0]-waypointX, viewCenter[1]-waypointY);
        //var distance = Math.sqrt((Math.pow(viewCenter[0]-waypointX,2))+(Math.pow(viewCenter[1]-waypointY,2)))
        
        if (distance < minDistance) {
        	minDistance = distance;
        	nearestWaypoint = i;
        }
    }

    /*
    if(firstMove == true) {
		switch(direction) {
    		case "next": 	mapMoveToWaypoint(0); break;
    		case "prev": 	mapMoveToWaypoint(waypointsLength - 1); break;
    		default: 		mapMoveToWaypoint(0); break;
    	}
    	firstMove = false;
    	return;
	}
    */


    if (minDistance === 0) {
    	
    	var waypointToGoTo = 0;


    	switch(direction) {
    		case 'next': 
    			waypointToGoTo = nearestWaypoint+1; 
    			break;
    		case 'prev': 
    			waypointToGoTo = nearestWaypoint-1; 
    			break;

    	}
    	mapMoveToWaypoint(waypointToGoTo);
    } else {
        var indexToGoTo = nearestWaypoint;
        switch(direction) {
            case 'next': 
                indexToGoTo = nearestWaypoint+1; 
                break;
            case 'prev': 
                indexToGoTo = nearestWaypoint-1; 
                break;

        }

    	mapMoveToWaypoint(indexToGoTo);
    }
}

jQuery(document).on('click', '#next-waypoint', function(){
	findNearestWaypoint('next');
});
jQuery(document).on('click', '#prev-waypoint', function(){
	findNearestWaypoint('prev');
});


jQuery('body').on('keydown', function(event) {
	var key = event.key; // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
    if(key == 'ArrowLeft') {
        findNearestWaypoint('prev');
    } else if(key == 'ArrowRight') {
        findNearestWaypoint('next');
    }
});

var rotation = 0;
var gestureStartRotation = 0;

const pointInRect = function( pointList , point ){
    return (point[0] > pointList[0] && point[0] < pointList[2]) && (point[1] > pointList[1] && point[1] < pointList[3]);
}

var goToLayerOnClick = (projectMap, mapData) => {
    projectMap.on('singleclick', function(evt) { 
        mapData.elements.forEach(function(singleData, index) {
            if( pointInRect( singleData.extent , evt.coordinate) ){
                mapMoveToClicked(singleData);
            }
        });
    });
}

goToLayerOnClick(projectMap, mapData);
var moveToPoint = (rotation) => {
	projectView.setRotation(degrees_to_radians(rotation));
}


var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

window.addEventListener("gesturestart", function (e) {
    if(!isMobile) {
        e.preventDefault();
        gestureStartRotation = rotation;
    }
});

window.addEventListener("gesturechange", function (e) {
    if(!isMobile) {
        e.preventDefault();
        rotation = gestureStartRotation + e.rotation;
        moveToPoint(rotation);
    }
})

window.addEventListener("gestureend", function (e) {
    if(!isMobile) {
        e.preventDefault();
    }
});


